mutation CreateCalendarEventMutation($input: CreateCalendarEventInput!) {
  createCalendarEvent(input: $input) {
    calendarEvent {
      id
      type
      contest {
        id
      }
      website {
        id
      }
      startDate
      endDate
      contents {
        title
        description
        announcementLink
        feedbackLink
        language
      }
    }
  }
}